import e from "./TooltipContent_vue.js";
//#region src/components/ui/tooltip/core/TooltipContent.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=TooltipContent.js.map